const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Stock-Flow Structure ───────────────────────────────
function DiagramStockFlow() {
  const W = 900, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stock-and-Flow Structure — The Core Building Block</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowRmain" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="arrowGrey" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#777"/>
          </marker>
          <marker id="arrowBlue" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#2E75B6"/>
          </marker>
        </defs>

        {/* Cloud source */}
        <ellipse cx={80} cy={150} rx={40} ry={28} fill="#e8f4ff" stroke="#2E75B6" strokeWidth="2" strokeDasharray="5,3"/>
        <text x={80} y={154} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">Source</text>

        {/* Inflow pipe */}
        <line x1={120} y1={150} x2={208} y2={150} stroke="#c0392b" strokeWidth="4" markerEnd="url(#arrowRmain)"/>
        {/* Inflow valve (hourglass) */}
        <polygon points="170,135 190,135 180,150 190,165 170,165 180,150" fill="#c0392b" opacity="0.85"/>
        <text x={180} y={128} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Inflow Rate</text>
        <text x={180} y={118} textAnchor="middle" fontSize="10" fill="#555">dS/dt (positive)</text>

        {/* Stock box */}
        <rect x={210} y={110} width={160} height={80} rx={5} fill="#fff5f5" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={290} y={148} textAnchor="middle" fontSize="16" fill="#7B0D0D" fontWeight="700">STOCK</text>
        <text x={290} y={167} textAnchor="middle" fontSize="11" fill="#c0392b">S(t) = ∫ [in−out] dt</text>
        <text x={290} y={103} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Accumulation</text>

        {/* Outflow pipe */}
        <line x1={370} y1={150} x2={458} y2={150} stroke="#c0392b" strokeWidth="4" markerEnd="url(#arrowRmain)"/>
        <polygon points="400,135 420,135 410,150 420,165 400,165 410,150" fill="#c0392b" opacity="0.85"/>
        <text x={410} y={128} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Outflow Rate</text>
        <text x={410} y={118} textAnchor="middle" fontSize="10" fill="#555">dS/dt (negative)</text>

        {/* Cloud sink */}
        <ellipse cx={500} cy={150} rx={40} ry={28} fill="#fff0f0" stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3"/>
        <text x={500} y={154} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">Sink</text>

        {/* Auxiliary variable circle */}
        <circle cx={290} cy={250} r={28} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
        <text x={290} y={254} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Auxiliary</text>

        {/* Dashed arrow from auxiliary to inflow */}
        <line x1={265} y1={226} x2={212} y2={178} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#arrowGrey)"/>

        {/* Feedback arrow from stock to auxiliary */}
        <line x1={290} y1={190} x2={290} y2={222} stroke="#777" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#arrowGrey)"/>

        {/* Right panel */}
        <rect x={560} y={15} width={325} height={H-30} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={722} y={35} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Key Properties of Stocks</text>
        {[
          {y:45, bg:"#FEF0F0", bc:"#c0392b", text:["Memory: stocks carry state","forward through time"]},
          {y:100, bg:"#fff9e6", bc:"#e07b00", text:["Cannot change instantly —","only via flows over time"]},
          {y:155, bg:"#eaf3ff", bc:"#2E75B6", text:["Create inertia: resistance","to sudden system changes"]},
          {y:210, bg:"#fff0f0", bc:"#c0392b", text:["Decouple inflows from","outflows — sources of delay"]},
        ].map(({y, bg, bc, text}) => (
          <g key={y}>
            <rect x={566} y={y} width={313} height={50} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {text.map((t, i) => <text key={i} x={572} y={y+18+i*16} fontSize="12" fill="#333">{t}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The fundamental building block of any continuous system: a Stock (rectangle) accumulates or depletes over time through Inflows and Outflows (valves on pipes). Auxiliary variables (circles) represent information that influences flow rates. The dashed arrows carry information, not material.</div>
    </div>
  );
}

// ── Diagram 2: Feedback Loop Types ────────────────────────────────
function DiagramFeedbackLoops() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Feedback Loop Archetypes — Reinforcing (R) and Balancing (B)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowR" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="arrowB" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#2E75B6"/>
          </marker>
        </defs>

        {/* Panel 1: Reinforcing loop */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={32} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Reinforcing Loop (R) — Exponential Growth/Collapse</text>

        {(() => {
          const cx=10+PW/2, cy=165;
          // Nodes: Stock (top), NetGrowth (right), GrowthRate (bottom), (loop)
          return <>
            <rect x={cx-55} y={cy-90} width={110} height={44} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
            <text x={cx} y={cy-63} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Population</text>

            <circle cx={cx+100} cy={cy} r={30} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
            <text x={cx+100} y={cy+4} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Birth</text>
            <text x={cx+100} y={cy+16} textAnchor="middle" fontSize="10" fill="#7a4800">Rate</text>

            <circle cx={cx} cy={cy+90} r={30} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
            <text x={cx} y={cy+94} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Fertility</text>
            <text x={cx} y={cy+106} textAnchor="middle" fontSize="10" fill="#7a4800">Fraction</text>

            {/* Arrows — circular loop */}
            <path d={`M ${cx+55},${cy-68} Q ${cx+110},${cy-60} ${cx+128},${cy-30}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowR)"/>
            <path d={`M ${cx+108},${cy+28} Q ${cx+80},${cy+80} ${cx+30},${cy+88}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowR)"/>
            <path d={`M ${cx-30},${cy+88} Q ${cx-80},${cy+80} ${cx-108},${cy+28}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowR)"/>
            <path d={`M ${cx-128},${cy-30} Q ${cx-110},${cy-60} ${cx-55},${cy-68}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowR)"/>

            <circle cx={cx-100} cy={cy} r={30} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
            <text x={cx-100} y={cy+4} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Net</text>
            <text x={cx-100} y={cy+16} textAnchor="middle" fontSize="10" fill="#7a4800">Growth</text>

            {/* R label */}
            <circle cx={cx} cy={cy} r={20} fill="#fff0f0" stroke="#c0392b" strokeWidth="2"/>
            <text x={cx} y={cy+5} textAnchor="middle" fontSize="16" fill="#c0392b" fontWeight="700">R</text>

            <text x={cx} y={cy-108} textAnchor="middle" fontSize="11" fill="#27ae60">+ more population → more births → even more population</text>
          </>;
        })()}

        {/* Panel 2: Balancing loop */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={32} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Balancing Loop (B) — Goal-Seeking Behaviour</text>

        {(() => {
          const cx=PW+20+PW/2, cy=165;
          return <>
            <rect x={cx-55} y={cy-90} width={110} height={44} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
            <text x={cx} y={cy-63} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Temperature</text>

            <circle cx={cx+100} cy={cy} r={30} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
            <text x={cx+100} y={cy+4} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Cooling</text>
            <text x={cx+100} y={cy+16} textAnchor="middle" fontSize="10" fill="#7a4800">Rate</text>

            <circle cx={cx} cy={cy+90} r={30} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
            <text x={cx} y={cy+94} textAnchor="middle" fontSize="11" fill="#1a4a7a" fontWeight="700">Gap to</text>
            <text x={cx} y={cy+106} textAnchor="middle" fontSize="10" fill="#1a4a7a">Target</text>

            <path d={`M ${cx+55},${cy-68} Q ${cx+110},${cy-60} ${cx+128},${cy-30}`} fill="none" stroke="#2E75B6" strokeWidth="2" markerEnd="url(#arrowB)"/>
            <path d={`M ${cx+108},${cy+28} Q ${cx+80},${cy+80} ${cx+30},${cy+88}`} fill="none" stroke="#2E75B6" strokeWidth="2" markerEnd="url(#arrowB)"/>
            <path d={`M ${cx-30},${cy+88} Q ${cx-80},${cy+80} ${cx-108},${cy+28}`} fill="none" stroke="#2E75B6" strokeWidth="2" markerEnd="url(#arrowB)"/>
            <path d={`M ${cx-128},${cy-30} Q ${cx-110},${cy-60} ${cx-55},${cy-68}`} fill="none" stroke="#2E75B6" strokeWidth="2" markerEnd="url(#arrowB)"/>

            <circle cx={cx-100} cy={cy} r={30} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
            <text x={cx-100} y={cy+4} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Desired</text>
            <text x={cx-100} y={cy+16} textAnchor="middle" fontSize="10" fill="#7a4800">State</text>

            <circle cx={cx} cy={cy} r={20} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
            <text x={cx} y={cy+5} textAnchor="middle" fontSize="16" fill="#2E75B6" fontWeight="700">B</text>

            <text x={cx} y={cy-108} textAnchor="middle" fontSize="11" fill="#2E75B6">+ gap to goal → stronger corrective action → smaller gap</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>All system dynamics behaviour emerges from two loop types. Reinforcing loops (R) amplify deviation — producing exponential growth or collapse. Balancing loops (B) correct deviation toward a goal — producing equilibrium and oscillation. Complex systems contain many interacting loops whose dominance shifts over time.</div>
    </div>
  );
}

// ── Diagram 3: Behaviour Over Time — Growth, Equilibrium, Oscillation ─
function DiagramBehaviourModes() {
  const W = 900, H = 320;
  const pad = 16, panW = (W - pad*4) / 3;

  function makePolyline(pts) {
    return pts.map(([x,y]) => `${x},${y}`).join(' ');
  }

  // Panel 1: Exponential growth (reinforcing)
  const p1x = pad, p1y = 30, p1w = panW, p1h = 240;
  const growPts = [];
  for (let i=0; i<=50; i++) {
    const t = i/50;
    growPts.push([p1x+20+t*(p1w-30), p1y+p1h-20 - (Math.exp(t*2.5)-1)/(Math.exp(2.5)-1)*(p1h-40)]);
  }

  // Panel 2: S-curve (reinforcing + balancing)
  const p2x = pad*2+panW, p2y=30, p2h=240;
  const sCurvePts = [];
  for (let i=0; i<=50; i++) {
    const t=i/50;
    const v = 1/(1+Math.exp(-10*(t-0.4)));
    sCurvePts.push([p2x+20+t*(panW-30), p2y+p2h-20 - v*(p2h-40)]);
  }

  // Panel 3: Oscillation (balancing + delay)
  const p3x = pad*3+panW*2, p3y=30, p3h=240;
  const oscPts = [];
  for (let i=0; i<=60; i++) {
    const t=i/60;
    const v = 0.5 + 0.4*Math.exp(-t*2)*Math.cos(t*18);
    oscPts.push([p3x+20+t*(panW-30), p3y+p3h-20 - v*(p3h-40)]);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reference Modes of Behaviour — Three Fundamental Patterns</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1 */}
        <rect x={p1x} y={p1y} width={p1w} height={p1h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p1x+p1w/2} y={p1y+18} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">Exponential Growth</text>
        <text x={p1x+p1w/2} y={p1y+30} textAnchor="middle" fontSize="10" fill="#555">(dominant reinforcing loop)</text>
        <polyline points={makePolyline(growPts)} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={p1x+8} y={p1y+p1h-6} fontSize="10" fill="#888">t →</text>
        <text x={p1x+12} y={p1y+42} fontSize="10" fill="#888" transform={`rotate(-90,${p1x+12},${p1y+p1h/2})`}>S(t)</text>
        {/* Goal label */}
        <text x={p1x+p1w/2} y={p1y+p1h-28} textAnchor="middle" fontSize="10" fill="#c0392b">Doubling time: T₂ = ln2 / k</text>

        {/* Panel 2 */}
        <rect x={p2x} y={p2y} width={panW} height={p2h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p2x+panW/2} y={p2y+18} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">S-Shaped Growth</text>
        <text x={p2x+panW/2} y={p2y+30} textAnchor="middle" fontSize="10" fill="#555">(R loop + carrying-capacity B loop)</text>
        <polyline points={makePolyline(sCurvePts)} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        {/* Carrying capacity line */}
        <line x1={p2x+20} y1={p2y+20} x2={p2x+panW-10} y2={p2y+20} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="6,3" opacity="0.5"/>
        <text x={p2x+panW-12} y={p2y+18} textAnchor="end" fontSize="10" fill="#c0392b">K (carrying capacity)</text>
        <text x={p2x+8} y={p2y+p2h-6} fontSize="10" fill="#888">t →</text>

        {/* Panel 3 */}
        <rect x={p3x} y={p3y} width={panW} height={p3h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p3x+panW/2} y={p3y+18} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">Damped Oscillation</text>
        <text x={p3x+panW/2} y={p3y+30} textAnchor="middle" fontSize="10" fill="#555">(B loop + time delay)</text>
        <polyline points={makePolyline(oscPts)} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        {/* Equilibrium line */}
        <line x1={p3x+20} y1={p3y+p3h/2} x2={p3x+panW-10} y2={p3y+p3h/2} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="6,3" opacity="0.4"/>
        <text x={p3x+panW-12} y={p3y+p3h/2-4} textAnchor="end" fontSize="10" fill="#2E75B6">Equilibrium</text>
        <text x={p3x+8} y={p3y+p3h-6} fontSize="10" fill="#888">t →</text>

        {/* Bottom bar */}
        <rect x={pad} y={278} width={W-pad*2} height={36} rx={4} fill="#FEF0F0" stroke="#f0cece"/>
        <text x={W/2} y={292} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Loop dominance shifts over time — real systems combine these modes</text>
        <text x={W/2} y={308} textAnchor="middle" fontSize="10" fill="#555">Exponential → often transitions to S-curve → can oscillate near equilibrium with delays</text>
      </svg>
      <div style={S.dCaption}>All system dynamics behaviour reduces to combinations of these three patterns. Exponential growth occurs when a reinforcing loop dominates. S-shaped growth arises when a balancing (capacity) loop grows stronger as the system fills. Oscillation results from balancing loops with delays that cause the system to repeatedly overshoot its goal.</div>
    </div>
  );
}

// ── Diagram 4: Causal Loop Diagram conventions ────────────────────
function DiagramCLD() {
  const W = 900, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Causal Loop Diagram (CLD) — Notation and a Real Example: Predator–Prey</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowRf" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="arrowRed2" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Predator-Prey CLD */}
        {/* Prey box */}
        <rect x={60} y={110} width={130} height={44} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
        <text x={125} y={137} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Prey Pop.</text>

        {/* Predator box */}
        <rect x={400} y={110} width={130} height={44} rx={4} fill="#fff0f0" stroke="#c0392b" strokeWidth="2"/>
        <text x={465} y={137} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Predator Pop.</text>

        {/* Prey births (R loop) — up arrow from Prey to itself via top */}
        <path d="M 125,110 C 125,50 190,30 250,60 C 310,90 200,110 190,110" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowRf)"/>
        <text x={200} y={42} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">Prey Births (+)</text>
        <circle cx={148} cy={63} r={10} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={148} y={67} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">R</text>

        {/* Predation — prey → predator */}
        <path d="M 190,132 C 280,90 360,90 398,128" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowRed2)"/>
        <text x={294} y={100} textAnchor="middle" fontSize="11" fill="#7B0D0D">Encounters (+)</text>

        {/* Predator deaths — prey reduces predators (negative) */}
        <path d="M 398,140 C 340,180 240,185 190,154" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowRed2)" strokeDasharray="5,2"/>
        <text x={294} y={197} textAnchor="middle" fontSize="11" fill="#7B0D0D">Predator Growth (+)</text>

        {/* Predators reduce prey */}
        <path d="M 465,154 C 465,230 125,240 125,154" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowRed2)"/>
        <text x={295} y={256} textAnchor="middle" fontSize="11" fill="#7B0D0D">Prey killed (−)</text>
        <circle cx={348} cy={240} r={10} fill="#fff0f0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={348} y={244} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">B</text>

        {/* Predator deaths */}
        <path d="M 465,110 C 465,40 530,20 570,50 C 610,80 530,110 520,110" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrowRed2)"/>
        <text x={540} y={32} textAnchor="middle" fontSize="11" fill="#7B0D0D">Predator Deaths (−)</text>

        {/* Legend */}
        <rect x={630} y={20} width={258} height={270} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={759} y={40} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">CLD Notation Guide</text>
        {[
          {y:55, col:"#c0392b", sym:"→ (+)", desc:"Same-direction causality"},
          {y:85, col:"#c0392b", sym:"→ (−)", desc:"Opposite-direction causality"},
          {y:115, col:"#c0392b", sym:"R loop", desc:"Reinforcing (self-amplifying)"},
          {y:145, col:"#2E75B6", sym:"B loop", desc:"Balancing (goal-seeking)"},
          {y:175, col:"#888", sym:"- - →", desc:"Delayed causal link"},
          {y:205, col:"#e07b00", sym:"‖ on link", desc:"Delay marker on causal arrow"},
          {y:235, col:"#555", sym:"Polarity", desc:"Sum of − links in loop: odd=B, even=R"},
        ].map(({y, col, sym, desc}) => (
          <g key={y}>
            <text x={642} y={y+13} fontSize="12" fill={col} fontWeight="700" fontFamily="'Courier New',monospace">{sym}</text>
            <text x={730} y={y+13} fontSize="11" fill="#333">{desc}</text>
            <line x1={636} y1={y+18} x2={882} y2={y+18} stroke="#f0cece" strokeWidth="1"/>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>A Causal Loop Diagram (CLD) maps cause-and-effect relationships with polarity signs. The classic predator-prey system illustrates how two interlocking balancing loops (Lotka-Volterra equations) produce sustained oscillation — neither population wins permanently; they cycle indefinitely.</div>
    </div>
  );
}

// ── Diagram 5: Integration & Differential Equations ───────────────
function DiagramIntegration() {
  const W = 900, H = 310;
  const PW = (W-30)/2;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Mathematical Core — Differential Equations & Euler Integration</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: ODE notation */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">ODE Representation of a Stock</text>

        {[
          { y: 55, label:"Stock equation:", code:"S(t) = S(t₀) + ∫[t₀→t] [I(τ) − O(τ)] dτ", col:"#7B0D0D" },
          { y: 100, label:"Differential form:", code:"dS/dt  =  I(t) − O(t)", col:"#c0392b" },
          { y: 145, label:"Euler (discrete approx.):", code:"S(t+dt) = S(t) + dt · [I(t) − O(t)]", col:"#2E75B6" },
          { y: 190, label:"Runge-Kutta (RK4):", code:"k₁=f(t,S)  k₂=f(t+dt/2, S+dt·k₁/2)\nS(t+dt) = S(t) + (dt/6)(k₁+2k₂+2k₃+k₄)", col:"#c0392b" },
        ].map(({y, label, code, col}) => (
          <g key={y}>
            <text x={22} y={y} fontSize="11" fill="#555" fontWeight="700">{label}</text>
            <rect x={20} y={y+4} width={PW-30} height={code.includes('\n')?44:28} rx={3} fill="#FEF0F0" stroke={col} strokeWidth="1.5"/>
            {code.split('\n').map((line, i) => (
              <text key={i} x={28} y={y+20+i*16} fontSize="12" fill={col} fontFamily="'Courier New',monospace" fontWeight="700">{line}</text>
            ))}
          </g>
        ))}

        <rect x={20} y={248} width={PW-30} height={46} rx={3} fill="#fff9e6" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={28} y={264} fontSize="11" fill="#7a4800" fontWeight="700">dt selection rule:</text>
        <text x={28} y={280} fontSize="11" fill="#333">dt ≤ smallest time constant / 4</text>
        <text x={28} y={292} fontSize="10" fill="#777">(prevents numerical instability — Euler diverges with large dt)</text>

        {/* Panel 2: Visual integration */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Euler Integration — Visualised</text>

        {(() => {
          const ox=PW+36, oy=260, ow=PW-46, oh=210;
          const pts=[];
          const eulerPts=[];
          const dt=0.12;
          for(let i=0;i<=50;i++){
            const t=i/50;
            const x=ox+t*ow;
            const y=oy-(0.5*(Math.exp(t*1.8)-1)/(Math.exp(1.8)-1))*oh;
            pts.push([x,y]);
          }
          let s=0;
          for(let i=0;i<=8;i++){
            const t=i/8;
            const x=ox+t*ow;
            const rate=0.5*1.8*Math.exp(t*1.8)/(Math.exp(1.8)-1);
            eulerPts.push([x, oy-s*oh]);
            s+=dt*rate;
          }
          return <>
            {/* Axes */}
            <line x1={ox} y1={oy+10} x2={ox+ow+14} y2={oy+10} stroke="#888" strokeWidth="1.5"/>
            <polygon points={`${ox+ow+14},${oy+6} ${ox+ow+20},${oy+10} ${ox+ow+14},${oy+14}`} fill="#888"/>
            <line x1={ox} y1={oy+10} x2={ox} y2={oy-oh-14} stroke="#888" strokeWidth="1.5"/>
            <polygon points={`${ox-4},${oy-oh-14} ${ox},${oy-oh-20} ${ox+4},${oy-oh-14}`} fill="#888"/>
            <text x={ox+ow+22} y={oy+14} fontSize="11" fill="#555">t</text>
            <text x={ox-10} y={oy-oh-22} fontSize="11" fill="#555">S</text>

            {/* True curve */}
            <polyline points={pts.map(([x,y])=>`${x},${y}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
            <text x={ox+ow-2} y={pts[pts.length-1][1]-6} textAnchor="end" fontSize="10" fill="#c0392b">True S(t)</text>

            {/* Euler steps */}
            {eulerPts.slice(0,-1).map(([x,y],i) => {
              const [nx,ny]=eulerPts[i+1];
              return <g key={i}>
                <line x1={x} y1={y} x2={nx} y2={y} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="3,2"/>
                <line x1={nx} y1={y} x2={nx} y2={ny} stroke="#c0392b" strokeWidth="1" strokeDasharray="2,2" opacity="0.5"/>
                <circle cx={x} cy={y} r={3} fill="#c0392b"/>
              </g>;
            })}
            <text x={ox+ow*0.6} y={oy-oh*0.3} fontSize="10" fill="#c0392b">Euler approx. (dt steps)</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>Every stock in a continuous model is formally an integral of its net flow over time. Simulation engines solve these ODEs numerically using Euler integration (simple, prone to error) or Runge-Kutta methods (more accurate). Choosing an appropriately small dt is critical — too large and the approximation diverges from the true trajectory.</div>
    </div>
  );
}

// ── Diagram 6: Delays ─────────────────────────────────────────────
function DiagramDelays() {
  const W = 900, H = 310;
  const PW = (W-30)/2;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Delays — Pipeline vs. Exponential Delay and Their Effects</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Pipeline (material) delay */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Pipeline (Fixed) Delay — τ = constant</text>

        {(() => {
          const stages = ["Order\nPlaced","WIP 1","WIP 2","WIP 3","Delivery"];
          const sx=28, sy=130, sw=68, sh=50, gap=14;
          return <>
            {stages.map((label, i) => {
              const x=sx+i*(sw+gap), isStock=i>0&&i<4;
              return <g key={i}>
                {isStock
                  ? <rect x={x} y={sy} width={sw} height={sh} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
                  : <ellipse cx={x+sw/2} cy={sy+sh/2} rx={sw/2} ry={sh/2-4} fill="#fff9e6" stroke="#e07b00" strokeWidth="2" strokeDasharray="4,3"/>
                }
                {label.split('\n').map((t,j) => (
                  <text key={j} x={x+sw/2} y={sy+20+j*16} textAnchor="middle" fontSize="10" fill="#7B0D0D" fontWeight={isStock?"700":"400"}>{t}</text>
                ))}
                {i<stages.length-1 && (
                  <>
                    <line x1={x+sw} y1={sy+sh/2} x2={x+sw+gap} y2={sy+sh/2} stroke="#c0392b" strokeWidth="2"/>
                    <polygon points={`${x+sw+gap},${sy+sh/2-4} ${x+sw+gap+6},${sy+sh/2} ${x+sw+gap},${sy+sh/2+4}`} fill="#c0392b"/>
                  </>
                )}
              </g>;
            })}
            <text x={10+PW/2} y={210} textAnchor="middle" fontSize="11" fill="#555">Output(t) = Input(t − τ)  — exact copy, time-shifted</text>
            <rect x={20} y={220} width={PW-30} height={42} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
            <text x={28} y={236} fontSize="11" fill="#7B0D0D" fontWeight="700">Uses: supply chains, construction projects, gestation</text>
            <text x={28} y={252} fontSize="10" fill="#555">Each unit spends exactly τ time units in the pipeline</text>
            <text x={28} y={264} fontSize="10" fill="#555">before emerging. No smoothing — input spike → output spike.</text>
          </>;
        })()}

        {/* Panel 2: Exponential (information) delay */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Exponential (Smooth) Delay — 1st-Order</text>

        {(() => {
          const ox=PW+36, oy=250, ow=PW-46, oh=190;
          // Input: step at t=0.15
          const inputPts=[], outputPts=[];
          let delayed=0.1;
          const tau=0.28;
          for(let i=0;i<=60;i++){
            const t=i/60;
            const input=t<0.2?0.1:0.8;
            delayed += (1/60)*(input-delayed)/tau;
            const x=ox+t*ow;
            inputPts.push([x, oy-input*oh]);
            outputPts.push([x, oy-delayed*oh]);
          }
          return <>
            <line x1={ox} y1={oy+8} x2={ox+ow+14} y2={oy+8} stroke="#888" strokeWidth="1.5"/>
            <polygon points={`${ox+ow+14},${oy+4} ${ox+ow+20},${oy+8} ${ox+ow+14},${oy+12}`} fill="#888"/>
            <line x1={ox} y1={oy+8} x2={ox} y2={oy-oh-14} stroke="#888" strokeWidth="1.5"/>
            <text x={ox+ow+22} y={oy+12} fontSize="10" fill="#555">t</text>
            <text x={ox-8} y={oy-oh-18} fontSize="10" fill="#555">v</text>

            <polyline points={inputPts.map(([x,y])=>`${x},${y}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="6,3"/>
            <text x={ox+ow*0.35} y={oy-oh*0.88} fontSize="10" fill="#e07b00" fontWeight="700">Input (step)</text>

            <polyline points={outputPts.map(([x,y])=>`${x},${y}`).join(' ')} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
            <text x={ox+ow*0.7} y={oy-oh*0.62} fontSize="10" fill="#2E75B6" fontWeight="700">Delayed output</text>

            <rect x={PW+26} y={262} width={PW-16} height={36} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
            <text x={PW+32} y={277} fontSize="11" fill="#1a4a7a" fontWeight="700">dD/dt = (Input − D) / τ</text>
            <text x={PW+32} y={292} fontSize="10" fill="#555">Smooths input; τ = average delay time (63% response)</text>
          </>;
        })()}
      </svg>
      <div style={S.dCaption}>Delays are among the most important and dangerous structures in system dynamics. Pipeline delays shift material or information without distortion — a spike in remains a spike, just later. Exponential (first-order) delays smooth the input signal, causing the output to lag and approach the input asymptotically. Delays interacting with balancing loops create oscillation.</div>
    </div>
  );
}

// ── Diagram 7: System Archetypes ──────────────────────────────────
function DiagramArchetypes() {
  const W = 900, H = 290;
  const cols = ['#c0392b','#2E75B6','#c0392b','#9b59b6','#e07b00','#27ae60'];
  const archetypes = [
    { name:"Limits to Growth", desc:"R loop drives growth until a B loop (constraint) tightens — growth slows, stalls, or collapses.", loops:"R + B", example:"Market growth vs. market saturation" },
    { name:"Shifting the Burden", desc:"Symptomatic fix relieves pressure, reducing incentive to address root cause. Dependency grows.", loops:"2×B + R", example:"Pain relief vs. treating underlying illness" },
    { name:"Escalation", desc:"Two actors each perceive the other's action as threatening and respond in kind — arms race.", loops:"R (coupled)", example:"Price wars, military buildups" },
    { name:"Tragedy of the Commons", desc:"Each actor increases use of a shared resource; overuse depletes it, hurting all actors.", loops:"R + B (shared)", example:"Overfishing, shared bandwidth" },
    { name:"Fixes that Fail", desc:"A fix produces unintended side effects that create the original problem again after a delay.", loops:"B + delayed R", example:"Borrowing to pay debt" },
    { name:"Growth & Underinvestment", desc:"Demand growth stresses capacity; under-investment in capacity limits growth, eroding standard.", loops:"R + 2×B", example:"Infrastructure, IT systems" },
  ];
  const cardW = (W - 30) / 3, cardH = 124;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>System Archetypes — Recurring Problematic Structures</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {archetypes.map((a, i) => {
          const col = i % 3, row = Math.floor(i / 3);
          const x = 10 + col * (cardW + 5), y = 10 + row * (cardH + 6);
          const c = cols[i];
          return (
            <g key={i}>
              <rect x={x} y={y} width={cardW} height={cardH} rx={5} fill="#fff" stroke={c} strokeWidth="1.5"/>
              <rect x={x} y={y} width={cardW} height={24} rx={4} fill={c}/>
              <text x={x+cardW/2} y={y+16} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{a.name}</text>
              <text x={x+8} y={y+38} fontSize="10" fill="#888" fontWeight="700">LOOPS: {a.loops}</text>
              {a.desc.match(/.{1,52}(\s|$)/g).slice(0,3).map((line,j) => (
                <text key={j} x={x+8} y={y+52+j*14} fontSize="10.5" fill="#333">{line.trim()}</text>
              ))}
              <rect x={x+6} y={y+cardH-26} width={cardW-12} height={20} rx={2} fill={c} opacity="0.1"/>
              <text x={x+cardW/2} y={y+cardH-13} textAnchor="middle" fontSize="9.5" fill={c} fontWeight="700">e.g. {a.example}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>System archetypes are generic causal structures that recur across industries, societies, and ecosystems. Identifying which archetype a situation resembles immediately suggests both the system's future behaviour and the high-leverage intervention point to address it.</div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────
export default function ContinuousSystems() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Continuous Systems in System Dynamics</h1>
      <p style={S.p}>
        System dynamics is a methodology for studying and managing complex feedback systems — such as those found in business, ecology, economics, and engineering. Continuous system dynamics treats state variables as smooth functions of time, governed by differential equations. The central insight is that the structure of a system — its stocks, flows, and feedback loops — determines its behaviour over time, often in counterintuitive ways that defy simple cause-and-effect analysis.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Stocks accumulate flows over time — they are the memory, inertia, and state of a system",
        "Flows are rates of change — the only way to alter a stock is through its inflows or outflows",
        "Feedback loops cause a system's behaviour to be self-referential: outputs become inputs",
        "Reinforcing loops amplify change (exponential growth or collapse); balancing loops resist change (equilibrium, oscillation)",
        "Delays between cause and effect are a primary source of oscillation and policy resistance",
        "The same structure produces the same behaviour regardless of the physical domain",
        "Non-linearity: relationships between variables are rarely proportional — limits, thresholds, and saturation are the norm",
        "Counter-intuitive behaviour: high-leverage policy points are often far removed in time and space from the symptom",
      ]}/>

      <h2 style={S.h2}>Stocks, Flows, and Auxiliaries</h2>
      <p style={S.p}>
        The fundamental accounting identity of system dynamics is that a stock at any time equals its initial value plus the integral of all net flows into it. Stocks change only through flows — they cannot jump instantaneously. This seemingly simple constraint creates the inertia, lags, and momentum that make systems difficult to steer.
      </p>
      <DiagramStockFlow/>
      <Table2 rows={[
        ["Stock (Level)","A quantity that accumulates or depletes over time\nS(t) = S(t₀) + ∫ [Inflow(τ) − Outflow(τ)] dτ\nExamples: water in a bathtub, population, capital, inventory"],
        ["Flow (Rate)","Rate of change of a stock (units of stock per unit time)\nThe only way to change a stock — flows can be positive (inflow) or negative (outflow)\nExamples: birth rate, depreciation, sales"],
        ["Auxiliary variable","An intermediate variable that translates information into flow rates\nNot a stock — can change instantaneously\nExamples: delivery delay, desired production rate, price"],
        ["Constant / parameter","A fixed value that does not change during a simulation run\nExamples: tax rate, physical constants, policy targets"],
        ["Connector (information arc)","Carries information (not material) from one variable to another\nShown as dashed arrows in stock-flow diagrams"],
        ["Clouds","Represent infinite sources or sinks outside the model boundary\nAssumption: they are not affected by what happens inside the model"],
      ]}/>

      <h2 style={S.h2}>Feedback Loops</h2>
      <p style={S.p}>
        A feedback loop exists whenever a change in a stock eventually influences the flows into or out of that same stock. Feedback is the mechanism by which systems are self-regulating or self-amplifying. Every structure in system dynamics — every pattern of behaviour, every archetype — is built from combinations of just two types of loop.
      </p>
      <DiagramFeedbackLoops/>
      <Table2 rows={[
        ["Reinforcing (R) loop","Also called positive feedback. Amplifies perturbations — a small change snowballs.\nLoop polarity: even number of negative links (including zero)\nBehaviour: exponential growth (or collapse)\nExamples: compound interest, viral spread, learning curves"],
        ["Balancing (B) loop","Also called negative feedback. Corrects deviation from a goal.\nLoop polarity: odd number of negative links\nBehaviour: equilibrium-seeking, oscillation (with delays)\nExamples: thermostat, population-food balance, inventory control"],
        ["Loop polarity rule","Count the '−' polarity links around the loop:\nOdd number of '−' links → Balancing loop (B)\nEven number of '−' links (including 0) → Reinforcing loop (R)"],
        ["Dominant loop","At any moment, one loop exerts more influence than others\nDominance shifts as stocks change → behaviour mode shifts over time\nExplains why a system that grows exponentially may later plateau"],
        ["Feedback delay","A delay within a feedback loop stretches the loop's 'time constant'\nCauses overshoot and oscillation in balancing loops\nLonger delay → stronger oscillation, harder to damp"],
      ]}/>

      <h2 style={S.h2}>Behaviour Modes</h2>
      <p style={S.p}>
        Every pattern of behaviour observed in continuous systems — from the growth of a startup to the oscillation of a supply chain — can be traced to the structure of feedback loops and the delays between them. System dynamics identifies a small set of fundamental modes, and real systems are superpositions of these.
      </p>
      <DiagramBehaviourModes/>
      <Table2 rows={[
        ["Exponential growth","One dominant reinforcing loop, no limiting constraints yet active\ndS/dt = kS  →  S(t) = S₀ eᵏᵗ\nDoubling time T₂ = ln(2)/k ≈ 70/(%growth rate)"],
        ["Exponential decay","One dominant balancing loop draining a stock\ndS/dt = −kS  →  S(t) = S₀ e⁻ᵏᵗ\nHalf-life T½ = ln(2)/k"],
        ["Goal-seeking (asymptote)","Balancing loop pulling stock toward a fixed goal\ndS/dt = (Goal − S)/τ  →  S(t) = Goal − (Goal−S₀)e^(−t/τ)\nTime constant τ: time to close 63% of the gap"],
        ["S-shaped (logistic)","Reinforcing loop dominates early; balancing (capacity) loop dominates later\ndP/dt = rP(1 − P/K)  K = carrying capacity\nInflection at P = K/2; then decelerating approach to K"],
        ["Oscillation","Balancing loop + delay: system overshoots goal, corrects, overshoots again\nUnderdamped: oscillations decay toward equilibrium\nSustained: loop gain exactly offsets damping\nGrowth oscillation: oscillation superimposed on exponential trend"],
        ["Chaos","Nonlinear reinforcing loops in bounded systems can produce deterministic chaos\nSensitive to initial conditions; not random but unpredictable long-term\nLorenz attractor, logistic map at high r values"],
      ]}/>

      <h2 style={S.h2}>Causal Loop Diagrams</h2>
      <p style={S.p}>
        A Causal Loop Diagram (CLD) is a qualitative representation of system structure. It maps the variables and the causal relationships between them — including polarity — without committing to specific functional forms or initial conditions. CLDs are invaluable for communicating system structure to stakeholders and for hypothesis generation before building a formal simulation model.
      </p>
      <DiagramCLD/>
      <Table2 rows={[
        ["Causal link polarity (+)","An increase in A causes an increase in B (or a decrease causes a decrease)\nSame-direction relationship — both variables move together"],
        ["Causal link polarity (−)","An increase in A causes a decrease in B (or a decrease causes an increase)\nOpposite-direction relationship — variables move in opposing directions"],
        ["Link delay marker (‖)","Two parallel bars on a causal arrow indicate a significant time delay\nRemind analysts to look for oscillation and policy resistance"],
        ["CLD limitations","Cannot show stock-flow structure precisely; loop polarity can be ambiguous\nNot runnable — must be converted to a stock-flow model for simulation\nUseful for communication but not quantitative prediction"],
        ["Lotka-Volterra example","dx/dt = αx − βxy   (prey: grows alone, killed by predators)\ndy/dt = δxy − γy   (predators: fed by prey, die naturally)\nTwo interlocked B loops → sustained oscillations"],
      ]}/>

      <h2 style={S.h2}>Mathematical Core — ODEs and Numerical Integration</h2>
      <p style={S.p}>
        Every continuous system dynamics model is a system of ordinary differential equations (ODEs), one for each stock. Because these equations usually cannot be solved analytically, simulation engines integrate them numerically step by step using a chosen integration method and time step (dt).
      </p>
      <DiagramIntegration/>
      <Table2 rows={[
        ["Euler method","S(t+dt) = S(t) + dt · f(t, S(t))\nFirst-order; simple but accumulates error — use only for exploratory work or very small dt\nError ∝ dt (first-order accuracy)"],
        ["Runge-Kutta 4 (RK4)","Evaluates f at four points per step; weighted average gives 4th-order accuracy\nError ∝ dt⁴ — dramatically more accurate than Euler for same dt\nDefault integrator in Vensim, Stella Architect, AnyLogic"],
        ["dt (time step)","Must be ≤ smallest time constant in the model ÷ 4\nToo large: numerical instability, false oscillations\nToo small: excessive computation time, no practical benefit\nRule of thumb: start at dt = 0.0625×(smallest τ)"],
        ["Time constants","τ = 1 / (fractional flow rate) for a first-order stock\nSmallest τ governs numerical stability requirements\nAll meaningful system behaviour occurs over timescales >> τ"],
        ["Unit consistency","Every equation must be dimensionally consistent (units cancel correctly)\nCommon errors: flows with wrong units, dimensionless ratios missing"],
        ["Steady-state check","Set all derivatives = 0 and solve for equilibrium analytically\nVerify simulation converges to the correct equilibrium at large t"],
      ]}/>

      <h2 style={S.h2}>Delays in Continuous Systems</h2>
      <p style={S.p}>
        Delays are among the most consequential structures in any model. They separate cause from effect in time, and are the primary reason managers experience counter-intuitive, oscillating system behaviour. There are two fundamental categories: material (pipeline) delays, where things take a fixed time to traverse a process, and information (exponential) delays, which smooth and lag signals.
      </p>
      <DiagramDelays/>
      <Table2 rows={[
        ["Pipeline (transit) delay","Fixed transit time τ; all units spend exactly τ time in the process\nOutput(t) = Input(t − τ)\nImplemented as a chain of n identical first-order delays (n-order pipeline): n → ∞ → perfect pipeline\nExamples: gestation period, construction time, shipping lead time"],
        ["First-order exponential delay","dD/dt = (Input − D) / τ    where τ = average delay time\nOutput D(t) responds exponentially: 63% of step input reached at t=τ, 95% at t=3τ\nExamples: averaging, perception delay, order fulfilment from inventory"],
        ["Higher-order delays","Chaining n first-order delays narrows the output distribution around τ\n3rd-order: reasonable approximation of pipeline delay\nSmoothness ∝ n; perceived delay ≈ nτ"],
        ["Delay and oscillation","Balancing loop + pipeline delay → oscillation\nAmplitude of oscillation ∝ delay length\nBullwhip effect: small demand fluctuations amplify up a supply chain\nThe longer the delay relative to the adjustment time, the more severe the oscillation"],
        ["Information delays","Forecasting, averaging, or perception processes create information delays\nPerceived price ≠ actual price → misinformed decisions → boom-bust cycles\nAdjusting the averaging time is often the highest-leverage intervention"],
      ]}/>

      <h2 style={S.h2}>Non-Linearity</h2>
      <p style={S.p}>
        Real systems are non-linear: doubling an input rarely doubles an output. Non-linearities create thresholds, capacity limits, diminishing returns, and tipping points. They are the reason simple linear intuitions fail for complex systems — and why models must represent them carefully.
      </p>
      <Table2 rows={[
        ["Table functions (lookup)","Graphical relationship between two variables; arbitrary non-linear shape\nCaptures empirical relationships without assuming functional form\nExamples: effect of inventory ratio on order rate; worker productivity vs. fatigue"],
        ["Multiplicative non-linearity","Effects combine by multiplication: rate = normal_rate × effect₁ × effect₂ ×…\nAllows multiple factors to jointly modulate a flow\nEach 'effect' function normalised to 1.0 at normal conditions"],
        ["Capacity / resource limits","Flows cannot exceed resource availability: actual ≤ MIN(desired, available)\nCreates hard upper bounds; source of abrupt behaviour change at capacity"],
        ["Threshold effects","A variable must exceed a critical level before triggering a process\nBelieve: 'nothing happens until X > threshold' → sharp non-linearity"],
        ["Co-flows","Track the composition or attributes of stocks flowing through a system\nE.g., average skill level in a workforce as hiring/attrition changes the mix\nNecessary when heterogeneous units have different attributes that matter"],
        ["Tipping points (bifurcations)","At a critical parameter value, the system's qualitative behaviour changes\nSystem may jump from a desired equilibrium to an undesired one\nHysteresis: returning below the tipping point does not restore original state"],
      ]}/>

      <h2 style={S.h2}>System Archetypes</h2>
      <p style={S.p}>
        Peter Senge and colleagues identified a set of recurring generic system structures — archetypes — that appear across organisations and ecosystems. Recognising an archetype immediately reveals the system's typical failure mode and the high-leverage intervention, which is almost always structural rather than symptomatic.
      </p>
      <DiagramArchetypes/>
      <Table2 rows={[
        ["Limits to Growth","R loop drives growth until an eroding B loop kicks in\nLeverage: strengthen the limiting factor before it constrains — don't push harder on the R loop\nMistake: try to grow faster when growth slows → accelerates eventual collapse"],
        ["Shifting the Burden","Symptomatic fix erodes investment in fundamental solution\nLeverage: reduce symptomatic fix, invest heavily in fundamental solution; or acknowledge addiction explicitly\nMistake: keep applying the symptomatic fix because it works in the short term"],
        ["Escalation","Mutual reinforcing loops cause arms-race dynamics\nLeverage: unilateral de-escalation; make the loop visible to both parties\nMistake: try to 'win' the arms race — amplifies the loop"],
        ["Tragedy of Commons","Individual actors' locally rational behaviour depletes a shared resource\nLeverage: regulate access; make total load and per-actor load visible; establish mutual constraints\nMistake: trust individual self-restraint without structural incentives"],
        ["Fixes that Fail","Short-term fix has delayed side effects that recreate the problem\nLeverage: anticipate and manage side effects; use the fix sparingly; prefer fundamental solutions\nMistake: increase dosage of the fix when its effect wanes"],
        ["Eroding Goals","Gap between goal and performance is closed by lowering the goal rather than improving performance\nLeverage: anchor the goal externally; make goal erosion visible; reinforce commitment\nMistake: treat goal adjustment as rational adaptation"],
      ]}/>

      <h2 style={S.h2}>Model Confidence and Testing</h2>
      <p style={S.p}>
        A system dynamics model is not a prediction machine — it is a vehicle for understanding. Model confidence is built through a battery of structural and behavioural tests, not through fitting historical data alone. A model that passes these tests earns the right to be used for policy design.
      </p>
      <Table2 rows={[
        ["Boundary adequacy","Does the model include all stocks and flows needed to generate the problem behaviour?\nTest: add a candidate omitted structure — does behaviour change significantly?"],
        ["Structure assessment","Does each equation make physical and conceptual sense?\nUnits must balance; relationships must be empirically justifiable"],
        ["Dimensional consistency","Every variable must have consistent, physically meaningful units throughout\nSoftware (Vensim, Stella) performs automated unit checks"],
        ["Extreme condition test","Set parameters to extreme (plausible) values — does the model behave sensibly?\nA well-formed model must not produce negative populations, infinite rates, etc."],
        ["Behaviour reproduction","Does the simulated behaviour match observed reference modes qualitatively?\n(Quantitative fit to history is less important than structural validity)"],
        ["Sensitivity analysis","Vary uncertain parameters over plausible range — do conclusions change?\nRobust policies hold across parameter uncertainty"],
        ["Policy resistance test","Does proposed policy produce the intended result in the model?\nTest for side effects, delays, and compensating feedback that erode policy effectiveness"],
      ]}/>

      <h2 style={S.h2}>Practical Applications</h2>
      <Table2 rows={[
        ["Supply chain / operations","Bullwhip effect: demand variability amplifies upstream\nPolicy levers: reduce information delay, reduce order adjustment aggressiveness, share POS data"],
        ["Epidemiology (SIR model)","S→I→R stocks with infection and recovery flows\ndI/dt = β·S·I/N − γ·I    R₀ = β/γ (basic reproduction number)\nHerd immunity threshold: 1 − 1/R₀"],
        ["Corporate growth","Hiring → workforce → productivity → revenue → hiring budget (R loop)\nFriction: training delay, burnout, market saturation (B loops)"],
        ["Climate systems","CO₂ stock, temperature stock, ice-albedo R loop, carbon cycle B loops\nLong delays (decades) mean committed warming exceeds current warming"],
        ["Urban dynamics","Forrester's Urban Dynamics: housing, business, workers interacting stocks\nShows why urban renewal programmes often fail — symptom relief, not structure change"],
        ["Project management","Brooks' Law: adding staff to a late project makes it later\nRamp-up time, training burden, communication overhead stocks defeat the intuitive fix"],
        ["Fisheries management","Harvest rate vs. fish stock regeneration: B loop\nOverharvesting collapses regeneration → stock crashes below recovery threshold\nMSY (maximum sustainable yield) sits at inflection of regeneration function"],
      ]}/>

      <InfoBox title="Key Equations Reference" items={[
        "Stock update:  S(t+dt) = S(t) + dt · [Inflow(t) − Outflow(t)]",
        "First-order goal-seeking:  dS/dt = (Goal − S) / τ   →   S(t) = Goal − (Goal−S₀)·e^(−t/τ)",
        "Exponential growth:  dS/dt = k·S   →   S(t) = S₀·eᵏᵗ    Doubling time: T₂ = ln2/k",
        "Logistic growth:  dP/dt = r·P·(1 − P/K)   Equilibrium at P* = K",
        "First-order exponential delay:  dD/dt = (Input − D)/τ",
        "Lotka-Volterra:  dx/dt = αx − βxy;   dy/dt = δxy − γy",
        "SIR epidemic:  dS/dt = −βSI/N;   dI/dt = βSI/N − γI;   dR/dt = γI    R₀ = β/γ",
        "Loop polarity test:  odd number of '−' causal links in loop → Balancing (B); even → Reinforcing (R)",
      ]}/>
    </div>
  );
}